module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/paypal-aa8a268131a66e87ebdb2bac6445c3aa.svg";